import UIkit from 'uikit/dist/js/uikit-core';

const initFiltroDiccionario = () => {
    const diccionario = document.querySelector('.contenedor-diccionario');
    if (!diccionario) return;

    let bloques = Array.from(document.querySelectorAll('.contenedor-diccionario .letra-diccionario'));
    const botonesFiltro = document.querySelectorAll('.filtro-letra');

    const letrasPorPagina = 2;
    let paginaActual = 1;
    let filtroActivo = null;

    let totalPaginas = Math.ceil(bloques.length / letrasPorPagina);

    let btnPrev = document.getElementById('diccionario-prev');
    let btnNext = document.getElementById('diccionario-next');
    let indicador = document.getElementById('diccionario-indicador');
    let contenedorNumeros = document.getElementById('diccionario-numeros');
    let contenedorPaginacion = document.querySelector('.diccionario-paginacion');

    if (!bloques.length) return;

    // =========================
    // PAGINACIÓN
    // =========================
    function renderPagina(pagina) {
        const inicio = (pagina - 1) * letrasPorPagina;
        const fin = inicio + letrasPorPagina;

        bloques.forEach((bloque, index) => {
            bloque.style.display = (index >= inicio && index < fin) ? '' : 'none';
        });

        const primeraLetra = bloques[inicio]?.querySelector('.letra')?.textContent?.trim() || '';
        const ultimaLetra = bloques[Math.min(fin - 1, bloques.length - 1)]?.querySelector('.letra')?.textContent?.trim() || '';

        if (indicador) {
            indicador.textContent = `${primeraLetra} - ${ultimaLetra}`;
        }

        if (btnPrev) {
            btnPrev.disabled = pagina === 1;
        }

        if (btnNext) {
            btnNext.disabled = pagina === totalPaginas;
        }

        actualizarBotonesNumericos();
    }

    function actualizarBotonesNumericos() {
        const botones = contenedorNumeros.querySelectorAll('button');
        botones.forEach((btn, index) => {
            btn.classList.toggle('active', index + 1 === paginaActual);
        });
    }

    function crearBotonesNumericos() {
        if (!contenedorNumeros) return;

        contenedorNumeros.innerHTML = '';

        for (let i = 1; i <= totalPaginas; i++) {
            const btn = document.createElement('button');
            btn.textContent = i;
            btn.classList.add('diccionario-numero');

            btn.addEventListener('click', () => {
                paginaActual = i;
                renderPagina(paginaActual);
                scrollTop();
            });

            contenedorNumeros.appendChild(btn);
        }
    }

    function scrollTop() {
        window.scrollTo({
            top: document.querySelector('.contenedor-diccionario').offsetTop + 300,
            behavior: 'smooth'
        });
    }

    // =========================
    // FILTRO POR LETRA
    // =========================
    botonesFiltro.forEach(btn => {
        btn.addEventListener('click', function () {
            const letra = this.dataset.letra;
            const busquedaActiva = input && input.value.trim() !== '';

            // UI active
            botonesFiltro.forEach(b => b.classList.remove('active'));
            this.classList.add('active');

            // =========================
            // 👉 CASO: TODOS
            // =========================
            if (letra === 'todos') {
                filtroActivo = null;

                // Mostrar paginación
                if (contenedorPaginacion) {
                    contenedorPaginacion.style.display = '';
                }

                // Ocultar mensaje sin resultados
                const sinResultados = document.querySelector('.sin-resultados');
                if (sinResultados) sinResultados.style.display = 'none';

                // Reset a página 1
                paginaActual = 1;
                renderPagina(paginaActual);
                scrollTop();

                return; // 🔥 IMPORTANTE
            }

            filtroActivo = letra;

            // UI active
            botonesFiltro.forEach(b => b.classList.remove('active'));
            this.classList.add('active');

            // Mostrar solo la letra seleccionada
            let hayResultados = false;

            bloques.forEach(bloque => {
                const letraBloque = bloque.querySelector('.letra')?.textContent?.trim();

                if (letraBloque === letra) {
                    bloque.style.display = '';
                    hayResultados = true;
                } else {
                    bloque.style.display = 'none';
                }
            });

            // Mostrar / ocultar mensaje
            const sinResultados = document.querySelector('.sin-resultados');

            if (sinResultados) {
                sinResultados.style.display = hayResultados ? 'none' : 'block';
            }

            // Ocultar paginación
            if (contenedorPaginacion) {
                contenedorPaginacion.style.display = 'none';
            }

            indicador.textContent = letra;

            const botonFiltro = document.querySelector('.boton-filtro-dropdown span');

            if (botonFiltro) {
                if (letra === 'todos') {
                    botonFiltro.textContent = 'Letra';
                } else {
                    botonFiltro.textContent = letra;
                }
            }
            
            if (busquedaActiva && letra !== 'todos') {
                botonesFiltro.forEach(b => b.classList.remove('active'));
                this.classList.add('active');

                const botonFiltro = document.querySelector('.boton-filtro-dropdown span');
                if (botonFiltro) {
                    botonFiltro.textContent = letra;
                }

                scrollToLetra(letra);
                return;
            } else {
                scrollToDiccionario();
            }
        });
    });

    function scrollToDiccionario() {
        const contenedor = document.querySelector('.contenedor-diccionario');

        if (!contenedor) return;

        const offset = 40; // ajusta si tienes header fijo
        const top = contenedor.getBoundingClientRect().top + window.pageYOffset + offset;

        window.scrollTo({
            top: top,
            behavior: 'smooth'
        });
    }

    // =========================
    // RESET (click doble o botón extra opcional)
    // =========================
    function resetFiltro() {
        filtroActivo = null;

        botonesFiltro.forEach(b => b.classList.remove('active'));

        if (contenedorPaginacion) {
            contenedorPaginacion.style.display = '';
        }

        paginaActual = 1;
        renderPagina(paginaActual);
    }

    // 👉 OPCIONAL: doble click para reset
    botonesFiltro.forEach(btn => {
        btn.addEventListener('dblclick', resetFiltro);
    });

    // =========================
    // BOTONES PREV / NEXT
    // =========================
    btnPrev.addEventListener('click', () => {
        if (paginaActual > 1 && !filtroActivo) {
            paginaActual--;
            renderPagina(paginaActual);
            scrollTop();
        }
    });

    btnNext.addEventListener('click', () => {
        if (paginaActual < totalPaginas && !filtroActivo) {
            paginaActual++;
            renderPagina(paginaActual);
            scrollTop();
        }
    });

    // =========================
    // BUSCADOR INPUT
    // =========================
    const input = document.querySelector('.buscar-diccionario');
    const contenedor = document.querySelector('.contenedor-diccionario');
    const sinResultados = document.querySelector('.sin-resultados');
    const htmlInicialDiccionario = contenedor ? contenedor.innerHTML : '';

    // INIT
    crearBotonesNumericos();
    renderPagina(paginaActual);

    if (!input || !contenedor) return;

    let timeout = null;

    input.addEventListener('input', function () {
        clearTimeout(timeout);

        const search = this.value.trim();

        if (search === '') {
            reiniciarDiccionario();
            return;
        }

        timeout = setTimeout(() => {
            buscarDiccionario(search);
        }, 350);
    });

    function buscarDiccionario(search) {
        fetch('/wp-json/diccionario-rest/v1/search', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-WP-Nonce': user_acciones_rest.apiNonce
            },
            body: JSON.stringify({
                data: {
                    search: search
                }
            })
        })
        .then(response => response.json())
        .then(response => {
            if (!response.success) return;

            pintarResultados(response.resultados, search);
        })
        .catch(error => {
            console.error('Error buscando diccionario:', error);
        });
    }

    function pintarResultados(resultados, search) {
        contenedor.innerHTML = '';

        if (contenedorPaginacion) {
            contenedorPaginacion.style.display = 'none';
        }

        if (indicador) {
            indicador.textContent = '';
        }

        if (!resultados.length) {
            if (sinResultados) {
                sinResultados.style.display = 'block';
            }
            return;
        }

        if (sinResultados) {
            sinResultados.style.display = 'none';
        }

        const grupos = {};

        resultados.forEach(item => {
            const letra = item.nombre.charAt(0).toUpperCase();

            if (!grupos[letra]) {
                grupos[letra] = [];
            }

            grupos[letra].push(item);
        });

        Object.keys(grupos).sort().forEach(letra => {
            const bloque = document.createElement('div');
            bloque.classList.add('letra-diccionario');

            let html = `
                <div class="uk-grid uk-grid-medium uk-child-width-1-2@m uk-child-width-1-1" uk-grid>
                    <div>
                        <h3 class="letra">${escapeHtml(letra)}</h3>
                    </div>
            `;

            grupos[letra].forEach(item => {
                html += `
                    <div>
                        <div class="termino-diccionario">
                            <h4 class="nombre">${resaltarBusqueda(item.nombre, search)}</h4>
                            <p class="descripcion">${resaltarBusqueda(item.descripcion, search)}</p>
                        </div>
                    </div>
                `;
            });

            html += `</div>`;

            bloque.innerHTML = html;
            contenedor.appendChild(bloque);
        });

        if (window.UIkit) {
            UIkit.update(contenedor);
        }
    }

    function escapeHtml(text) {
        return String(text)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#039;');
    }

    function resaltarBusqueda(texto, busqueda) {
        if (!busqueda) return escapeHtml(texto);

        const textoSeguro = escapeHtml(texto);
        const regex = new RegExp(`(${busqueda})`, 'gi');

        return textoSeguro.replace(regex, '<span class="busqueda">$1</span>');
    }

    function reiniciarDiccionario() {
        contenedor.innerHTML = htmlInicialDiccionario;

        if (sinResultados) {
            sinResultados.style.display = 'none';
        }

        if (contenedorPaginacion) {
            contenedorPaginacion.style.display = '';
        }

        botonesFiltro.forEach(btn => btn.classList.remove('active'));

        const botonTodos = document.querySelector('.filtro-letra[data-letra="todos"]');
        if (botonTodos) {
            botonTodos.classList.add('active');
        }

        const botonFiltroTexto = document.querySelector('.boton-filtro-dropdown span');
        if (botonFiltroTexto) {
            botonFiltroTexto.textContent = 'Letra';
        }

        filtroActivo = null;

        refrescarPaginacion();

        if (window.UIkit) {
            UIkit.update(contenedor);
        }
    }

    function refrescarPaginacion() {
        refrescarElementosPaginacion();

        bloques = Array.from(document.querySelectorAll('.contenedor-diccionario .letra-diccionario'));
        totalPaginas = Math.ceil(bloques.length / letrasPorPagina);
        paginaActual = 1;
        filtroActivo = null;

        if (!bloques.length || !contenedorNumeros || !btnPrev || !btnNext) return;

        crearBotonesNumericos();
        renderPagina(paginaActual);

        btnPrev.onclick = () => {
            if (paginaActual > 1 && !filtroActivo) {
                paginaActual--;
                renderPagina(paginaActual);
                scrollTop();
            }
        };

        btnNext.onclick = () => {
            if (paginaActual < totalPaginas && !filtroActivo) {
                paginaActual++;
                renderPagina(paginaActual);
                scrollTop();
            }
        };
    }

    function refrescarElementosPaginacion() {
        btnPrev = document.getElementById('diccionario-prev');
        btnNext = document.getElementById('diccionario-next');
        indicador = document.getElementById('diccionario-indicador');
        contenedorNumeros = document.getElementById('diccionario-numeros');
        contenedorPaginacion = document.querySelector('.diccionario-paginacion');
    }

    function scrollToLetra(letra) {
        const bloquesActuales = Array.from(document.querySelectorAll('.contenedor-diccionario .letra-diccionario'));

        const bloque = bloquesActuales.find(bloque => {
            const letraBloque = bloque.querySelector('.letra')?.textContent?.trim();
            return letraBloque === letra;
        });

        if (!bloque) {
            scrollToDiccionario();
            return;
        }

        const offset = 80;
        const top = bloque.getBoundingClientRect().top + window.pageYOffset - offset;

        window.scrollTo({
            top: top,
            behavior: 'smooth'
        });
    }
};

export default initFiltroDiccionario;